<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-12">
        <h-title with-mb>Product</h-title>
      </div>
      <div class="col-lg-6 col-12">
        <div class="row">
          <div class="col-lg-3 col-12 py-2">
            <base-select :options="[{value: 'all', text: 'Show All'}]" p="0.60rem 1rem" rounded="pill" />
          </div>
          <div class="col-lg-5 col-9 py-2">
            <base-input placeholder="Search" fcSize="md" v-model="search" p="0.5rem 1rem" />
          </div>
          <div class="col-lg-1 col-3 py-2">
            <base-button class="p-0" bg="black" d="flex" rounded="circle" w="40px" h="40px" icon="search" />
          </div>
          <div class="col-lg-3 col-6 py-2">
            <base-button tag="router-link" to="/product/form" bg="black" rounded="pill"  p="0.5rem 1rem"><i class="fas fa-plus me-3 text-white"></i><small class="text-white">Add New</small></base-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="table-responsive">
        <data-table
          class="table table-borderless align-middle w-100"
          :options="dOptions"
          :columns="dColumns"
          :data="dData">
          <thead>
              <tr>
                  <th width="25%">Product Name</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Stock</th>
                  <th>Price</th>
                  <th width="10%">Action</th>
              </tr>
          </thead>
        </data-table>
      </div>
      <div class="row">
        <div class="col-xl-2 col-lg-4 col-12">
          <div class="d-flex align-items-center justify-content-between">
            <base-select class="mr-3" :options="[{value: 'bulk', text: 'Bulk Action'}]" rounded="pill" />
            <base-button bg="black" rounded="pill" p="0.25rem 1.75rem"><small class="text-white">Apply</small></base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HTitle from '@/components/text/BaseTitle'
import BaseSelect from '@/components/input/BaseSelect.vue'
import BaseInput from '@/components/input/BaseInput.vue'
import BaseButton from '@/components/BaseButton.vue'
export default {
  name: 'product-view',
  components: {
    HTitle,
    BaseSelect,
    BaseInput,
    BaseButton
},
  data() {
    return {
      search: '',
      dOptions: {
        searching: false,
        info: false,
        lengthChange: false,
        pageLength: 5,
        language: {
          paginate: {
            previous: '<i class="fas fa-caret-left fs-1"></i>',
            next: '<i class="fas fa-caret-right fs-1"></i>'
          }
        }
      },
      dColumns: [
        { name: 'product_name' },
        { name: 'type' },
        { name: 'status' },
        { name: 'stock' },
        { name: 'price' },
        { name: 'action' }
      ],
      dData: [
        [this.gNameProduct('CV0023', 'Convers Chuck Taylor', './assets/product-1.png'), 'Variant', 'Publish', 20, 200000, this.gAction('d')],
        [this.gNameProduct('CV0023', 'Convers Chuck Taylor', './assets/product-1.png'), 'Variant', 'Publish', 20, 200000, this.gAction('d')],
        [this.gNameProduct('CV0023', 'Convers Chuck Taylor', './assets/product-1.png'), 'Variant', 'Publish', 20, 200000, this.gAction('d')],
        [this.gNameProduct('CV0023', 'Convers Chuck Taylor', './assets/product-1.png'), 'Variant', 'Publish', 20, 200000, this.gAction('d')],
        [this.gNameProduct('CV0023', 'Convers Chuck Taylor', './assets/product-1.png'), 'Variant', 'Publish', 20, 200000, this.gAction('d')],
        [this.gNameProduct('CV0023', 'Convers Chuck Taylor', './assets/product-1.png'), 'Variant', 'Publish', 20, 200000, this.gAction('d')],
      ]
    }
  },
  mounted(){
    this.$store.state.transPanelMenu = 69;
  },
  methods: {
    gNameProduct(sku, productName, img) {
      return '<div class="d-flex align-items-center justify-content-start">' +
                this.gCheck(sku) + this.gBox(img) +
               '<div>' +
                  '<p class="m-0 fw-bold">' + productName + '</p>' +
                  '<p class="m-0">#' + sku + '</p>' +
              '</div>' +
            '</div>'
    },
    gCheck(val) {
      return '<div class="d-flex align-items-center">' +
              '<label class="checkbox bounce">' +
                  '<input type="checkbox" value="'+val+'">' +
                  '<svg viewBox="0 0 21 21">' +
                      '<polyline points="5 10.75 8.5 14.25 16 6"></polyline>' +
                  '</svg>' +
              '</label>' +
            '</div>'
    },
    gBox(img) {
      return '<div class="bg-gray d-flex align-items-center justify-content-center mx-4" style="border-radius:22px; width: 80px; height: 80px; padding:10px;">' +
                '<img class="w-100" src="' + img + '" />' +
              '</div>'
    },
    gAction() {
      return '<div class="d-flex align-items-center justify-content-between">' +
                this.gBtnAction('<i class="fas fa-eye"></i>') +
                this.gBtnAction('<i class="fas fa-clone"></i>') +
                this.gBtnAction('<i class="fas fa-pencil-alt"></i>') +
             '</div>'
    },
    gBtnAction(action) {
      return '<button type="button" class="bg-gray btn btn-action d-flex align-items-center justify-content-center">'+action+'</button>'
    }
  }
}
</script>

<style scoped>
  @import 'datatables.net-dt';
  @import 'datatables.net-bs5';
</style>